import React from 'react';
import { AppState } from 'src/redux/modules';
import { rulesEngine, Rule } from 'src/helpers/rulesEngine';
import { Dispatch } from 'redux';
import { MeasureSize } from 'src/components/Helpers';
import { RevealTransition } from 'src/components/Transitions';
import {
  ActivateYourPage,
  CountdownToRefunding,
  DonationsRefunded,
  DonationsRefundedSupporter,
  PageLive,
  PageClosedFullyFundedOwner,
  PageClosedFullyFundedSupporter,
  PageClosedTargetNotReachedOwner,
  PageClosedTargetNotReachedSupporter,
  RecurringDonationsPrompt,
  SayThanks,
  PageFrozenSupporter,
  DocumentsManualVerification,
  BankDetailsVerified,
} from 'src/components/Prompt';

export interface PromptRulesEngineOptions {
  pageSection: string;
  dispatch: Dispatch<AppState>;
  promptTransitionActive?: boolean;
  activatePromptTransition: (options: { height: number }) => void;
  closePrompt: () => void;
}

const ownerPrompts: Rule<JSX.Element, PromptRulesEngineOptions>[] = [
  DonationsRefunded,
  DocumentsManualVerification,
  BankDetailsVerified,
  CountdownToRefunding,
  ActivateYourPage,
  PageLive,
  SayThanks,
  RecurringDonationsPrompt,
  PageClosedFullyFundedOwner,
  PageClosedTargetNotReachedOwner,
];

const supporterPrompts: Rule<JSX.Element, PromptRulesEngineOptions>[] = [
  PageClosedTargetNotReachedSupporter,
  PageClosedFullyFundedSupporter,
  DonationsRefundedSupporter,
  PageFrozenSupporter,
];

const promptRulesEngine = (
  appState: AppState,
  isOwner: boolean,
  {
    pageSection,
    dispatch,
    promptTransitionActive,
    activatePromptTransition,
    closePrompt,
  }: PromptRulesEngineOptions
) => {
  try {
    const prompt = rulesEngine(
      isOwner ? [...ownerPrompts] : [...supporterPrompts],
      appState,
      {
        pageSection,
        dispatch,
        promptTransitionActive,
        activatePromptTransition,
        closePrompt,
      }
    );

    if (prompt.matched && prompt.result) {
      const style: React.CSSProperties = {
        position: 'absolute',
        width: '100%',
        zIndex: promptTransitionActive ? 0 : -1,
      };

      // hack: without the wrapping section React 16.0.0 tries to merge the transition divs, breaking the layout
      return (
        <MeasureSize style={style} onMeasure={activatePromptTransition}>
          <RevealTransition
            active={promptTransitionActive}
            delay="0.5s"
            duration="1s"
          >
            {prompt.result}
          </RevealTransition>
        </MeasureSize>
      );
    }

    return null;
  } catch (e) {
    return null;
  }
};

export default promptRulesEngine;



// WEBPACK FOOTER //
// ./src/helpers/prompts/index.tsx